{
  "total": "总资产估值",
  "available": "可用余额",
  "frozen": "锁定资产",
  "bonus-balance": "奖励余额",
  "bonus-balance-label": "奖励余额：{{amount}}",
  "action": {
    "deposit": "收币",
    "convert": "闪兑",
    "buySellOrder": "买卖币",
    "customerService": "客服"
  },
  "assets": "资产",
  "coin": {
    "YBB": "宝币",
    "usdt": "USDT"
  },
  "ticketUsed": "该抽奖券已被使用或失效。",
  "ticketWin": "恭喜获得 {{amount}}{{label}}",
  "ticketNoPrize": "未中奖，再接再厉！",
  "tickets": "抽奖券",
  "close": "关闭",
  "ticketLoadFailed": "无法加载抽奖券，请稍后再试。",
  "noTickets": "目前没有可用的抽奖券。",
  "unclaimedTicket": "您有一个红包尚未领取，请点击领取！",
  "drawNow": "立即抽奖",
  "loginToViewTickets": "请先登录后查看抽奖券。",
  "drawResultUnavailable": "未能获取抽奖结果，请稍后再试。",
  "drawFailed": "抽奖失败，请稍后再试。",
  "drawFailedTitle": "抽奖失败"
}
